import React from 'react';
import styled from 'styled-components';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import Tokens from '@grnhse/seedling/lib/birch/tokens';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { ScorecardIcons } from 'shared/components/scorecard_icons/scorecard_icons';
import type { IconType } from 'shared/components/scorecard_icons/base_icons';
import type { ScorecardRatingsSummary } from 'talent_matching/types';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix(
  'talent_matching.panel.rediscovery_application_history'
);

type RatingConfig = {
  key: keyof ScorecardRatingsSummary;
  iconType: IconType;
  color: string;
};

const RATINGS: RatingConfig[] = [
  { key: 'strong_no', iconType: 'strong_no', color: FullPalette.POPPY_E300 },
  { key: 'no', iconType: 'no', color: FullPalette.POPPY_E100 },
  { key: 'yes', iconType: 'yes', color: FullPalette.GREEN_600 },
  { key: 'strong_yes', iconType: 'strong_yes', color: FullPalette.GREEN_E400 },
  { key: 'no_decision', iconType: 'no_decision', color: FullPalette.GREY_600 },
];

const Pill = styled.div<{ bgColor: string; active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${Tokens.spacing['0.5']};
  padding: ${Tokens.spacing['1']};
  width: 100px;
  border-radius: 5px;
  background-color: ${({ bgColor }) => bgColor};
  opacity: ${({ active }) => (active ? 1 : 0.25)};
`;

type Props = {
  summary: ScorecardRatingsSummary;
};

const ScorecardRatingPills = ({ summary }: Props) => {
  return (
    <Stack direction="row" spacing={2}>
      {RATINGS.map(({ key, iconType, color }) => (
        <Tooltip
          key={key}
          label={t(key, { count: summary[key] })}
          ariaLabel={t(key, { count: summary[key] })}
        >
          <Pill bgColor={color} active={summary[key] > 0}>
            <ScorecardIcons type={iconType} className={`small_icon`} />
            <Body>{summary[key]}</Body>
          </Pill>
        </Tooltip>
      ))}
    </Stack>
  );
};

export default ScorecardRatingPills;
